import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StepperService} from '@shared/services';
import {RETURN_BACK_TO_RCSA_PARAM} from '@shared/common/constants';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-routing',
  templateUrl: './routing.component.html',
  styleUrls: []
})
export class RoutingComponent implements OnInit {

  constructor(private router: Router, public stepperService: StepperService) {
  }

  ngOnInit(): void {
    console.log("UA RG: ", navigator.userAgent);
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.router.navigate(['/unsupported-device']);
      return;
    }
    const routeURL = localStorage.getItem('routerUrl');
    console.log('ROUTING SAVED URL', routeURL);
    localStorage.removeItem('routerUrl');
    if (routeURL) {
      console.log('ROUTING - SAVED OTHER URL, NAVIGATE', routeURL);
      const params = new URLSearchParams(routeURL.substring(routeURL.indexOf('?') + 1));
      console.log('ROUTING - SAVED OTHER URL, PARAMS', this.paramsToObject(params.entries()));
      if (routeURL == '/') {
        window.location.href = environment.rcsaUrl + RETURN_BACK_TO_RCSA_PARAM;
      } else if (routeURL.indexOf('?') > -1) {
        this.router.navigate([routeURL.substring(0, routeURL.indexOf('?'))], {queryParams: this.paramsToObject(params.entries())});
      } else {
        this.router.navigate([routeURL]);
      }
    } else {
      this.stepperService.resetRiskCase();
      console.log('ROUTING', 'DEFAULT - MANDATE');
      window.location.href = environment.rcsaUrl + RETURN_BACK_TO_RCSA_PARAM;
    }
  }


  private paramsToObject(entries) {
    const result = {}
    for (const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }

}
